import React from 'react';
import { HangupButton } from './HangupButton';
import { setPrejoinPageVisibility } from '../../prejoin';
import { translate } from '../../base/i18n';
import { connect } from 'react-redux';
import { WHITEBOARD_CLOSE_COMMAND } from './../../whiteboard/constants'

class RPC_HangupButton extends HangupButton {

    _doHangup() {
        if(window && window.isWhiteboardByMe) {
            const { conference } = APP.store.getState()['features/base/conference'];
            let _this=this
            conference.sendCommandOnce(WHITEBOARD_CLOSE_COMMAND, { value: window.isWhiteboardByMe, tp: Date.now() });
            setTimeout(function(){
                _this._doHangupwithWB();
                _this.props.dispatch(setPrejoinPageVisibility(true));
                window.socket.disconnect();                
            },300)
        } else {
            super._doHangup();
            this.props.dispatch(setPrejoinPageVisibility(true));
            window.socket.disconnect(); 
        }
    }

    _doHangupwithWB(){
        super._doHangup();
    }
}

export default translate(connect()(RPC_HangupButton));